import { RSAA } from 'redux-api-middleware'
import { map, mergeDeepRight, pick, pipe, prop } from 'ramda'
import { getApiPath, mapObjectKeys, webStorage } from 'sidecar-utility-library'

import { types, initialState } from './index'
import { arrayToOptions, getOptionsFrom } from './utils.js'

export const fetchExpenseFilterOptions = () => ({
  [RSAA]: {
    endpoint: getApiPath(
      'exp',
      `expenses/search-filters?accountUuid=${webStorage.getItem('aud')}`,
    ),
    method: 'GET',
    types: [
      types.FETCH_EXPENSE_FILTER_OPTIONS_REQUEST,
      types.FETCH_EXPENSE_FILTER_OPTIONS_SUCCESS,
      types.FETCH_EXPENSE_FILTER_OPTIONS_ERROR,
    ],
  },
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.FETCH_EXPENSE_FILTER_OPTIONS_REQUEST: {
      return {
        ...state,
        busy: true,
      }
    }

    case types.FETCH_EXPENSE_FILTER_OPTIONS_SUCCESS: {
      const updatedFilterOptions = pipe(
        mapObjectKeys({
          memberOptions: pipe(
            prop('members'),
            map(member => ({
              name: member.uuid,
              label: `${member.firstName} ${member.lastName}`,
              value: member.uuid,
            })),
          ),
          sortOptions: getOptionsFrom('sortedBy'),
          expenseTypes: getOptionsFrom('type'),
          priceRangeOptions: getOptionsFrom('amounts'),
          statusOptions: pipe(getOptionsFrom('status')),
          providers: pipe(prop('providers'), arrayToOptions),
        }),
        pick([
          'memberOptions',
          'sortOptions',
          'statusOptions',
          'expenseTypes',
          'priceRangeOptions',
          'providers',
        ]),
      )(payload)

      let nextState = {
        ...state,
        filterOptions: mergeDeepRight(
          state.filterOptions,
          updatedFilterOptions,
        ),
        busy: false,
      }

      return nextState
    }

    case types.FETCH_EXPENSE_FILTER_OPTIONS_ERROR: {
      return {
        ...state,
        busy: false,
      }
    }

    default:
      return state
  }
}
